import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { verifyOTP } from "../../redux/auth/actions";

const useOTPVerification = () => {
  const [otp, setOTP] = useState(["", "", "", ""]);
  const userOtp = useSelector((state) => state.auth.userOTP.data);
  const userSuccess = useSelector((state) => state.auth.user.success);
  const otpInputs = useRef([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleChange = (index, e) => {
    const newOTP = [...otp];
    newOTP[index] = e.target.value;
    setOTP(newOTP);
    if (e.target.value !== "" && otpInputs.current[index + 1]) {
      otpInputs.current[index + 1].focus();
    }
  };

  const handleKeyUp = (index, e) => {
    if (e.key === "Backspace" && otp[index] === "") {
      if (otpInputs.current[index - 1]) {
        otpInputs.current[index - 1].focus();
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const otpValue = otp.join("");
    if (userOtp?.otp?.toString() === otpValue) {
      dispatch(verifyOTP(userOtp));
    }
  };

  useEffect(() => {
    if (!userOtp?.otp) {
      navigate("/login");
    }
  }, []);

  useEffect(() => {
    if (userSuccess) {
      navigate("/home");
    }
  }, [userSuccess]);

  return {
    handleChange,
    handleSubmit,
    handleKeyUp,
    otp,
    otpInputs,
  };
};

export default useOTPVerification;
